export default __webpack_public_path__ + "static/media/guesty_step8.45ede536.png";